/* This file is autogenerated, see readme.md for instructions */
import TagAltSvgIcon from '@bloomreach/banana-theme/icons/tag-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TagAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TagAltSvgIcon />
    </Icon>
  );
});

TagAltIcon.displayName = 'TagAltIcon';

export default TagAltIcon;
